/**
 * Combined chat (Gorgias) + rewards (Smile) launcher.
 * Opening one closes the other. Each button only appears once its app is available.
 */
(() => {
  const wrapper = document.querySelector('[data-support-launcher]');
  if (!wrapper) return;

  const chatButton = wrapper.querySelector('[data-launcher-chat]');
  const rewardsButton = wrapper.querySelector('[data-launcher-rewards]');

  const reveal = (button) => {
    button.hidden = false;
    wrapper.hidden = false;
  };

  const poll = (check, done, attempts = 40) => {
    if (check()) return done();
    if (attempts > 0) setTimeout(() => poll(check, done, attempts - 1), 500);
  };

  // Gorgias
  const whenGorgias = (callback) => {
    if (window.GorgiasChat) {
      window.GorgiasChat.init().then(callback);
    } else {
      window.addEventListener('gorgias-widget-loaded', () => window.GorgiasChat.init().then(callback), { once: true });
    }
  };

  whenGorgias(() => {
    reveal(chatButton);
    chatButton.addEventListener('click', () => {
      if (window.GorgiasChat.isOpen()) {
        window.GorgiasChat.close();
        return;
      }
      if (window.SmileUI) window.SmileUI.closePanel();
      window.GorgiasChat.open();
    });
  });

  // Smile
  poll(() => window.SmileUI, () => {
    window.SmileUI.ready().then(() => {
      reveal(rewardsButton);
      rewardsButton.addEventListener('click', () => {
        if (window.GorgiasChat) window.GorgiasChat.close();
        window.SmileUI.openPanel();
      });
    });
  });
})();
